import React, { useEffect, useState } from 'react'
import Dialog from '../../common/Dialog'
import $t from '../../../i18n'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from 'antd'
import Actions from '../../../actions'
import MaterialInput from '../../common/MaterialInput'
import { getOwnerMember } from 'utils/memberUtils'
import { ROUTE_STEP } from 'consts/flowConsts'
import { useLocation } from 'react-router'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { isEmpty } from 'lodash'

import './SaveProgressDialog.css'

const getValidationErrors = ({ phone, email, ccEmail }) => {
  const result = {}

  // 11 digits - 10 phone + 1 country code
  const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (!email || !email?.toLowerCase()?.match(EMAIL_REGEX)) {
    result.email = $t('errors.validation.invalidEmail')
  }
  if (!!ccEmail && !ccEmail?.toLowerCase()?.match(EMAIL_REGEX)) {
    result.ccEmail = $t('errors.validation.invalidEmail')
  }
  if (!!phone && !isValidPhoneNumber(phone)) {
    result.phone = $t('errors.validation.invalidPhone')
  }

  return (!isEmpty(result) && result) || null
}

const SaveProgressDialog = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [ccEmail, setCcEmail] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [shouldValidate, setShouldValidate] = useState(false)

  const { isSaveProgressDialogVisible, isSaveProgressSuccess } = useSelector(
    state => state.app
  )
  const isSaveApplicationLoading = useSelector(
    state => state.application?.isSaveApplicationLoading
  )
  const members = useSelector(state => state.member.members)
  const ownerMember = getOwnerMember(members)

  const errors =
    shouldValidate && getValidationErrors({ phone, email, ccEmail })

  useEffect(() => {
    if (ownerMember) {
      setEmail(ownerMember?.email)
      setPhone(ownerMember?.phone)
    }
  }, [ownerMember])

  const closeDialog = () => {
    dispatch(Actions.createAction(Actions.SAVE_PROGRESS_DIALOG_CLOSED))
  }

  const updateOwnerFields = () => {
    // update email and phone for owner member
    dispatch(
      Actions.createAction(Actions.MEMBER_INFO_CHANGED, {
        key: 'email',
        value: email,
        id: ownerMember?.id
      })
    )
    dispatch(
      Actions.createAction(Actions.MEMBER_INFO_CHANGED, {
        key: 'phone',
        value: phone,
        id: ownerMember?.id
      })
    )
  }

  const onSend = () => {
    if (getValidationErrors({ phone, email, ccEmail })) {
      setShouldValidate(true)
      return
    }
    const path = location?.path ? location?.path : location?.pathname
    setShouldValidate(false)
    updateOwnerFields()
    dispatch(
      Actions.createAction(Actions.SAVE_PROGRESS_REQUESTED, {
        ccEmail,
        step: ROUTE_STEP[path],
        saveProgressEmailRequested: true,
        skipNavigation: true
      })
    )
  }
  return (
    <Dialog
      title={
        isSaveProgressSuccess
          ? $t('dialogs.saveProgressSuccess.title')
          : $t('dialogs.saveProgress.title')
      }
      isVisible={isSaveProgressDialogVisible}
      image={isSaveProgressSuccess ? 'success_circle.svg' : null}
      footerActions={[]}
      onCancel={closeDialog}
      className='save-progress-dialog'
      closable={!isSaveProgressSuccess}
    >
      <div className='save-progress-dialog-content'>
        <div className='save-progress-subtitle subtitle'>
          {isSaveProgressSuccess
            ? $t('dialogs.saveProgressSuccess.description')
            : $t('dialogs.saveProgress.description')}
        </div>
        <div className='fields-container'>
          {!isSaveProgressSuccess && (
            <div className='fields'>
              <MaterialInput
                label={$t('fields.email')}
                value={email}
                errorText={errors?.email}
                onChange={e => setEmail(e?.target?.value)}
              />
              <MaterialInput
                label={$t('fields.phoneOptional')}
                value={phone}
                type='phone'
                country='US'
                errorText={errors?.phone}
                onChange={phone => setPhone(phone)}
              />
              <div className='field-title'>
                {$t('dialogs.saveProgress.emailCopy')}
              </div>
              <MaterialInput
                label={$t('fields.ccEmailOptional')}
                value={ccEmail}
                errorText={errors?.ccEmail}
                onChange={e => setCcEmail(e?.target?.value)}
              />
            </div>
          )}
          <Button
            className='dialog-action'
            type='primary'
            onClick={isSaveProgressSuccess ? closeDialog : onSend}
            loading={isSaveApplicationLoading}
          >
            {isSaveProgressSuccess ? $t('common.close') : $t('common.continue')}
          </Button>
          {!isSaveProgressSuccess && (
            <div className='save-progress-note'>
              {$t('dialogs.saveProgress.note')}
            </div>
          )}
        </div>
      </div>
    </Dialog>
  )
}

export default SaveProgressDialog
